import { render, staticRenderFns } from "./ScholarshipsUpdate.vue?vue&type=template&id=3d862a7c"
import script from "./ScholarshipsUpdate.vue?vue&type=script&lang=js"
export * from "./ScholarshipsUpdate.vue?vue&type=script&lang=js"
import style0 from "./ScholarshipsUpdate.vue?vue&type=style&index=0&id=3d862a7c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports